class ComponentAccordion extends Theme.Component {
  connectedCallback() {
    super.connectedCallback();
    this.handleHashState();
    this.addDirectEvent('hashchange', window, this.handleHashState.bind(this));
  }

  toggleAccordion(detail, element) {
    const button = element;
    const key = button.dataset.key;
    const targetContent = this.querySelector(`.accordion-item-content[data-key="${key}"]`);
    const isOpen = targetContent ? getComputedStyle(targetContent).display !== 'none' : false;
    const hasToggleIcons = !!button.querySelector('.accordion-expand, .accordion-collapse');
    const nextState = isOpen ? !hasToggleIcons : true;

    const buttons = this.querySelectorAll('.accordion-header');
    const contents = this.querySelectorAll('.accordion-item-content');

    buttons.forEach((btn) => {
      const btnKey = btn.dataset.key;
      const expandIcon = btn.querySelector('.accordion-expand');
      const collapseIcon = btn.querySelector('.accordion-collapse');
      const shouldOpen = btnKey === key ? nextState : false;

      btn.setAttribute('aria-expanded', String(shouldOpen));

      if (expandIcon) {
        expandIcon.style.display = shouldOpen ? 'none' : 'block';
      }

      if (collapseIcon) {
        collapseIcon.style.display = shouldOpen ? 'block' : 'none';
      }
    });

    contents.forEach((content) => {
      const contentKey = content.dataset.key;
      const shouldOpen = contentKey === key ? nextState : false;

      content.style.display = shouldOpen ? 'block' : 'none';
    });
  }

  handleHashState() {
    const key = window.location.hash.replace('#', '');

    if (!key) {
      return;
    }

    this.setAccordionState(key, true);
  }

  setAccordionState(activeKey, activeState) {
    const buttons = this.querySelectorAll('.accordion-header');
    const contents = this.querySelectorAll('.accordion-item-content');

    buttons.forEach((btn) => {
      const btnKey = btn.dataset.key;
      const expandIcon = btn.querySelector('.accordion-expand');
      const collapseIcon = btn.querySelector('.accordion-collapse');
      const shouldOpen = btnKey === activeKey ? activeState : false;

      btn.setAttribute('aria-expanded', String(shouldOpen));

      if (expandIcon) {
        expandIcon.style.display = shouldOpen ? 'none' : 'block';
      }

      if (collapseIcon) {
        collapseIcon.style.display = shouldOpen ? 'block' : 'none';
      }
    });

    contents.forEach((content) => {
      const contentKey = content.dataset.key;
      const shouldOpen = contentKey === activeKey ? activeState : false;

      content.style.display = shouldOpen ? 'block' : 'none';
    });
  }
}

customElements.define('component-accordion', ComponentAccordion);